export const RequiredAsterisk = () => (
  <span className="text-indigo-500 font-inter-semibold-13px">*</span>
);
